export const CSS = {
  active: "is-active",
  breakingLeft: "is-breaking-left",
  clone: "is-clone",
  cookieConsent: "has-cookie-consent",
  equalised: "is-equalised",
  hidden: "is-hidden",
  hovered: "is-hovered",
  initialised: "is-initialised",
  landscape: "is-landscape",
  loggedIn: "is-logged-in",
  loggedOut: "is-logged-out",
  open: "is-open",
  overflowHidden: "overflow--hidden",
  portrait: "is-portrait",
  transitioning: "is-transitioning",
  videoPlaying: "is-playing-video",
  visible: "is-visible",
};
